import React from "react";
import { Badge } from "reactstrap";
import { useEarnings, daysUntil } from "../hooks/useEarnings";

interface Props {
  ticker: string;
  className?: string;
}

/**
 * Shows a small earnings-date badge when a ticker has earnings within 30 days.
 * Returns null if no upcoming earnings are found in the cache.
 */
export default function EarningsBadge({ ticker, className }: Props) {
  const getEarnings = useEarnings();
  const entry = getEarnings(ticker);
  if (!entry) return null;

  const d = daysUntil(entry.date);
  if (d < 0 || d > 30) return null;

  let label: string;
  if (d === 0) label = "Earnings Today";
  else if (d === 1) label = "Earnings Tomorrow";
  else label = `Earnings in ${d}d`;

  // Urgency colours: ≤3 days = warning amber, ≤7 = info, else secondary
  const color = d <= 3 ? "warning" : d <= 7 ? "info" : "secondary";

  return (
    <Badge
      color={color}
      className={className}
      title={`${entry.name} reports ${entry.date}${entry.eps_forecast ? ` · EPS est. ${entry.eps_forecast}` : ""}`}
      style={{ fontSize: 10, fontWeight: 500, cursor: "default" }}
    >
      📅 {label}
    </Badge>
  );
}
